const uiSchema = () => ({
  barcode: {
    'ui:disabled': true,
  },
  product_details: {
    'ui:disabled': true,
  },
  description: {
    'ui:disabled': true,
    'ui:widget': 'textarea',
  },
});

export default uiSchema;
